<ng-select [compareWith]="compare"
  [items]="(items | async) || []"
  [hideSelected]="true"
  [loading]="loading"
  [typeahead]="onInput"
  (scrollToEnd)="scrollToEnd()"
  (search)="search.emit($event)"
  [formControl]="formControl"
  [multiple]="multiple"
  [placeholder]="placeholder"
  [clearable]="true"
  [addTag]="addTag"
  [addTagText]="addTagText"
  [readonly]="readonly"
  [bindLabel]="bindLabel"
  [bindValue]="$any(bindValue)"
  [inputAttrs]="$any(inputAttrs)"
  appendTo="body"
  >
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span>{{ getLabelText(item) }}</span>
    @if (multiple) {
      <span class="ng-select-clear-icon" (click)="clear(item)" aria-hidden="true">×</span>
    }
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span>{{ getLabelText(item) }}</span>
  </ng-template>
  <ng-template ng-tag-tmp let-searchTerm="searchTerm">
    @if (addTagValid) {
      <span class="ng-select-custom__valid-tag">{{addTagText}} {{searchTerm}}</span>
    }
    @if (!addTagValid) {
      <span class="ng-select-custom__invalid-tag">{{addTagText}}</span>
    }
  </ng-template>
</ng-select>
